import 'leaflet-easyprint';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen.min';
import 'leaflet-measure/dist/leaflet-measure.fr';
import L from 'leaflet/dist/leaflet';
import Site from './site.model';

export default class SiteFormController {
	static $inject = [
		'$scope',
		'$timeout',
		'$state',
		'$stateParams',
		'SitesCommunicationService',
		'SitesService',
		'notification',
		'$location',
		'$anchorScroll',
		'MassiaApplicationService',
		'$uibModal',
		'$translate',
		'_',
		'RouterHistoryService',
		'globalizationManagementService',
		'moment',
		'ModalService',
		'ProduitsService',
		'PaginationService',
		'MOPService'
	];

	certificats = [];
	accreditationToDelete = [];

	constructor(
		$scope,
		$timeout,
		$state,
		$stateParams,
		SitesCommunicationService,
		SitesService,
		notification,
		$location,
		$anchorScroll,
		MassiaApplicationService,
		$uibModal,
		$translate,
		_,
		RouterHistoryService,
		globalizationManagementService,
		moment,
		ModalService,
		ProduitsService,
		PaginationService,
		MOPService
	) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.SitesCommunicationService = SitesCommunicationService;
		this.SitesService = SitesService;
		this.notification = notification;
		this.$location = $location;
		this.$anchorScroll = $anchorScroll;
		this.MassiaApplicationService = MassiaApplicationService;
		this.$uibModal = $uibModal;
		this.$translate = $translate;
		this.ModalService = ModalService;
		this.ProduitsService = ProduitsService;
		this.PaginationService = PaginationService;
		this._ = _;
		this.RouterHistoryService = RouterHistoryService;
		this.globalizationManagementService = globalizationManagementService;
		this.moment = moment;
		this.dateFormat = globalizationManagementService.getCurrentLanguage().dateFormat;
		this.MOPService = MOPService;
		this.fromDap = false;
		this.refreshKey = 0;
	}

	async $onInit() {
		this.fromDap = this.$stateParams.fromDap;
		this.application = this.MassiaApplicationService.getApplication();
		this.site = {};
		this.loading = false;
		this.listeGenresSite = [];
		this.produits = [];
		this.form = {
			entete: {},
			caracteristiquesUtilisateur: {},
			caracteristiquesProducteur: {},
			caracteristiquesClient: {},
			caracteristiquesFournisseur: {},
			caracteristiquesTransporteur: {},
			objectifs: {},
			indicateurs: {},
			niveaux: {},
			coordoneesBancaires: {},
			qualib: {}
			// certificationCe: {}
		};

		this.itemsByPageOptions = [20, 100, 200];

		if (!this.modalInstance) {
			this.genreSite = this.$stateParams.genre;
		} else {
			this.genrePourOuverture = this.genreSite;
			switch (this.genreSite) {
				case 1:
					this.genreSite = 'commerciaux';
					break;
				case 2:
					this.genreSite = 'clients';
					break;
				case 4:
					this.genreSite = 'producteurs';
					break;
				case 8:
					this.genreSite = 'fournisseurs';
					break;
				case 16:
					this.genreSite = 'transporteurs';
					break;
			}
		}
		this.listeGenresSite = await this.SitesService.getGenreSite();
		await this.updateGenre();

		await this.reset();
		this.getDomaine();

		if (this.genreSite == 'commerciaux') {
			this.MOPService.setMop([
				{ title: 'SITES.BREADCRUMBS.SITES_COMMERCIAUX_LIST', filename: 'SitesCommerciaux.pdf', application: 'gestion' },
				{ title: 'SOCIETES.FILTRES_SOC_SITES', filename: 'FiltresSocietesSites.pdf', application: 'gestion' },
				{ title: 'SITES.BREADCRUMBS.SITES_COMMERCIAUX_LIST', filename: 'SitesCommerciaux.pdf', application: 'gestion' },
				{ title: 'FACTURES.BREADCRUMBS.FACTURES_PONT', filename: 'PontComptable.pdf', application: 'gestion' }
			]);
		} else {
			this.MOPService.setMop([
				{ title: 'SITES.BREADCRUMBS.SITES_COMMERCIAUX_LIST', filename: 'SitesCommerciaux.pdf', application: 'gestion' },
				{ title: 'FACTURES.BREADCRUMBS.FACTURES_PONT', filename: 'PontComptable.pdf', application: 'gestion' }
			]);
		}
		this.hasUserAccessSiteCommercial = await this.SitesService.checkProfilRights(!!this.site?.id, 'siteutil');
	}

	getDomaine() {
		switch (this.genreSite) {
			case 'commerciaux':
				this.domaine = 'siteutil';
				break;
			case 'clients':
				this.domaine = 'siteclient';
				break;
			case 'producteurs':
				this.domaine = 'siteprod';
				break;
			case 'transporteurs':
				this.domaine = 'sitetransp';
				break;
			case 'fournisseurs':
				this.domaine = 'sitefourn';
				break;
			default:
				break;
		}
	}

	async updateGenre() {
		switch (this.genreSite) {
			case 'commerciaux':
				this.site.genreSite = 1;
				this.site.genreLibelle = this.$translate.instant('SITES.ISCOMMERCIAL'); //'Commercial';
				break;
			case 'clients':
				this.site.genreSite = 2;
				this.site.genreLibelle = this.$translate.instant('SITES.ISCLIENT'); //'Client';
				break;
			case 'producteurs':
				this.site.genreSite = 4;
				this.site.genreLibelle = this.$translate.instant('SITES.ISPRODUCTEUR'); //'Producteur';
				break;
			case 'transporteurs':
				this.site.genreSite = 16;
				this.site.genreLibelle = this.$translate.instant('SITES.ISTRANSPORTEUR'); //'Transporteur';
				break;
			case 'fournisseurs':
				this.site.genreSite = 8;
				this.site.genreLibelle = this.$translate.instant('SITES.ISFOURNISSEUR'); //'Fournisseur';
				break;
			default:
				break;
		}
	}

	open(domaine) {
		const _this = this;
		_this.source = this.site;
		_this.domaine = domaine;
		this.$uibModal
			.open({
				template: '<centre-gestion source="$ctrl.source" domaine="$ctrl.domaine" modal-instance="$ctrl.uibModalInstance"></centre-gestion>',
				controller: [
					'$uibModalInstance',
					function ($uibModalInstance) {
						const $ctrl = this;
						$ctrl.source = _this.source;
						$ctrl.domaine = _this.domaine;
						$ctrl.uibModalInstance = $uibModalInstance;
					}
				],
				controllerAs: '$ctrl',
				size: 'xxl',
				windowClass: 'modern-modal-fixed-footer',
				backdrop: 'static'
			})
			.result.then(
				function () {},
				function () {
					_this.refreshKey++;
				}
			);
	}

	$onDestroy() {
		this.$timeout.cancel(this.updateSiteTimeout);
		this.MOPService.resetMop();
	}

	async reset() {
		this.startLoading();
		this.tmp = {
			configurationBalance: null
		};

		const data = {
			id: !this.modalInstance ? this.$stateParams.id : undefined
		};

		if (data.id) {
			try {
				data.entete = await this.SitesService.getSiteEnteteById(data.id, this.site.genreSite, this.MassiaApplicationService.getApplication());

				data.caracteristiquesUtilisateur = await this.SitesService.getSiteValeursCaracteristiquesUtilisateurAssociationsById(data.id);
				data.caracteristiquesProducteur = await this.SitesService.getSiteValeursCaracteristiquesProducteurAssociationsById(data.id);
				data.caracteristiquesFournisseur = await this.SitesService.getSiteValeursCaracteristiquesFournisseurAssociationsById(data.id);
				data.niveaux = await this.SitesService.getSiteValeursNiveauxById(data.id);
				data.objectifs = await this.SitesService.getSiteObjectifById(data.id);
				data.caracteristiquesTransporteur = await this.SitesService.getSiteValeursCaracteristiquesTransporteurAssociationsById(data.id);
				data.caracteristiquesClient = await this.SitesService.getSiteValeursCaracteristiquesClientAssociationsById(data.id);
				data.coordonneesBancaires = await this.SitesService.getCoordonnees(data.id);
				data.genreSite = this.site.genreSite;
				data.genreLibelle = this.site.genreLibelle;

				switch (this.genreSite) {
					case 'commerciaux':
						this.domaineDocument = 3;
						break;
					case 'clients':
						this.domaineDocument = 4;
						break;
					case 'producteurs':
						this.domaineDocument = 2;
						break;
					case 'transporteurs':
						this.domaineDocument = 6;
						break;
					case 'fournisseurs':
						this.domaineDocument = 5;
						break;
					default:
						break;
				}
			} catch (err) {
				if (err.data) {
					this.notification.error(err.data);
				} else {
					throw err;
				}
				this.annuler();
			}

			this.tmp.configurationBalance = data.entete.configurationBalance;
			this.site = new Site(data, this.application);
		} else {
			this.site = new Site(data, this.application);

			// Initialisation du client à partir du prospect si la creation est faite à partir d'un prospect
			// lors de la transformation d'une proposition en commande
			if (this.$stateParams.fromProspect) {
				const prospect = await this.SitesService.getProspect(this.$stateParams.prospectId);
				const proposition = await this.SitesService.getProposition(this.$stateParams.propositionId);
				//this.site.entete.etatCompteSites = [proposition.offre.idSociete];

				const contactList = new Set();

				if (prospect.contactId) {
					contactList.add(prospect.contactId);
				}

				if (proposition.offre.idContact) {
					contactList.add(proposition.offre.idContact);
				}

				//this.site.entete.societeId = proposition.offre.idSociete;
				this.site.entete.paysId = prospect.paysId;
				this.site.entete.raisonSociale = prospect.civilite;
				this.site.entete.libelle = prospect.libelle;
				this.site.entete.adresse = prospect.adresse;
				this.site.entete.ville = prospect.ville;
				this.site.entete.codePostal = prospect.codePostal;
				this.site.entete.telephone = prospect.telephone;
				this.site.entete.fax = prospect.fax;
				this.site.entete.mail = prospect.email;
				this.site.entete.website = prospect.website;
				this.site.entete.fromWhatName = 'prospect';
				this.site.entete.fromWhatId = this.$stateParams.prospectId;
				this.site.entete.idContacts = Array.isArray(this.site.entete.idContacts)
					? [...this.site.entete.idContacts, ...contactList]
					: [...contactList];
			}

			if (this.fromDap && this.$stateParams.transporteur) {
				const t = this.$stateParams.transporteur;
				this.site.entete.libelle = t.libelle;
				this.site.entete.adresse = t.adresse;
				this.site.entete.ville = t.ville;
				this.site.entete.codePostal = t.codePostal;
				this.site.entete.telephone = t.telephone;
				this.site.entete.numRecipice = t.numRecepisse; //attetion orthographe du mot
				this.site.entete.siret = t.siret;
				this.site.entete.paysId = t.pays.id;
			}

			if (this.$stateParams.personneId) {
				const personne = await this.SitesService.getPersonneName(this.$stateParams.personneId);
				this.site.entete.personneId = personne.id;
				this.site.entete.personne = personne.libelle;
			}

			// SL recuperation des donnees du client divers via l Id pour pre-remplir le formulaire du client
			if (this.$stateParams.fromClientDivers) {
				this.clientDivers = await this.SitesService.getClientDivers(this.$stateParams.clientDiversId);
				this.site.entete.adresse = this.clientDivers.adresse;
				this.site.entete.codePostal = this.clientDivers.codePostal;
				this.site.entete.fax = this.clientDivers.fax;
				this.site.entete.paysId = this.clientDivers.idPays;
				this.site.entete.libelle = this.clientDivers.libelle;
				this.site.entete.mail = this.clientDivers.mail;
				this.site.entete.telephone = this.clientDivers.telephone;
				this.site.entete.ville = this.clientDivers.ville;
				this.site.entete.website = this.clientDivers.web;
				this.site.entete.raisonSociale = this.clientDivers.civilite;
				this.site.entete.fromWhatName = 'clientDivers';
				this.site.entete.fromWhatId = this.$stateParams.clientDiversId;
			}
			switch (this.genreSite) {
				case 'commerciaux':
					this.site.entete.isUtilisateur = true;
					this.domaineDocument = 3;
					break;
				case 'clients':
					this.site.entete.isClient = true;
					this.domaineDocument = 4;
					break;
				case 'producteurs':
					this.site.entete.isProducteur = true;
					this.domaineDocument = 2;
					break;
				case 'transporteurs':
					this.site.entete.isTransporteur = true;
					this.domaineDocument = 6;
					break;
				case 'fournisseurs':
					this.site.entete.isFournisseur = true;
					this.domaineDocument = 5;
					break;
				default:
					break;
			}
		}

		//otention du paramètre de coche auto des états comptes
		const cptOuvert = await this.SitesService.getCompteOuvertDefault();
		this.site.compteOuvertDefault = cptOuvert === '1' ? true : false;

		if (this.$stateParams.duplicate) {
			this.site.id = undefined;
			this.site.entete.code += '_copie';
		}

		this.ongletOpen = {
			isEnteteOpen: true,
			isCaracteristiqueUtilisateurOpen: false,
			isCaracteristiqueClientOpen: false,
			isCaracteristiqueFournisseurOpen: false,
			isCaracteristiqueProducteurOpen: false,
			isCaracteristiqueTransporteurOpen: false,
			isProduitProducteurOpen: false,
			isProduitClientOpen: false,
			isNiveauxHierarchiqueOpen: false,
			isObjectifsOpen: false,
			isIndicateursOpen: false,
			isSpecificitesOpen: false,
			coordoneesBancairesOpen: false,
			etatCompteOpen: false,
			isImportBLOpen: false,
			coordGeoOpen: false
		};

		this.$timeout.cancel(this.updateSiteTimeout);
		this.updateSiteTimeout = this.$timeout(() => this.stopLoading());
	}

	async planTopo() {
		if (this.$stateParams.id) {
			const planTopoSite = await this.SitesService.getPlanTopo(this.$stateParams.id);
			if (planTopoSite) {
				const mapMinZoom = 15;
				const mapMaxZoom = 20;
				const optionsTopo = {
					idSite: this.$stateParams.id,
					annee: planTopoSite.annee,
					minZoom: mapMinZoom,
					maxZoom: mapMaxZoom,
					opacity: 1.0,
					attribution: 'Rendered with <a href="http://www.maptiler.com/">MapTiler</a>',
					tms: false
				};
				const topo = L.tileLayer('assets/topo/{idSite}/{annee}/{z}/{x}/{y}.png', optionsTopo);
				topo.addTo(this.map);
				return topo;
			}
			return undefined;
		}
	}

	async getProspect(prospectId) {
		return await this.SitesService.getProspect(prospectId);
	}

	// boutons de validation
	async sauvegarder() {
		const generiqueDisabledChecked = await this.checkGeneriqueDisabled();
		if (generiqueDisabledChecked && this.checkValidity()) {
			this.startLoading();
			try {
				if (this.site.interface) {
					if (this.site.interface.id) {
						await this.SitesService.updateTransporteurInterface(this.site.id, this.site.interface);
					} else {
						await this.SitesService.createTransporteurInterface(this.site.id, this.site.interface);
					}
				}
				let id = false;
				this.site.entete.latitude = this.site.latitude;
				this.site.configurationBalance = this.tmp.configurationBalance;
				this.site.entete.longitude = this.site.longitude;
				if (this.site.id) {
					await this.SitesService.updateSite(this.site, this.application);
					this.notification.success('SITES.UPDATED');
					id = this.site.id;
				} else {
					id = await this.SitesService.createSite(this.site, this.application);

					if (this.$stateParams.fromProspect) {
						await this.SitesService.deleteProspect(this.$stateParams.prospectId, id);
					}

					if (this.modalInstance && this.idSitePourCompte && this.genrePourOuverture) {
						//ouvrir le compte
						await this.SitesService.ouvreComptePourSite(this.idSitePourCompte, id, this.genrePourOuverture);
					}
					this.notification.success('SITES.CREATED');
				}
				return id;
			} catch (err) {
				if (err.data) {
					this.notification.error(err.data);
				} else {
					throw err;
				}
				return false;
			} finally {
				this.stopLoading();
			}
		}
	}

	async appliquer() {
		//pour eviter que le composant entete ouvre le modal alert message
		const isFromSave = true;
		this.RouterHistoryService.ignoreNextRoute();
		const id = await this.sauvegarder();
		if (id && this.site.id) {
			await this.reset();
			this.$stateParams.fromSave = isFromSave;
		} else if (id) {
			if (this.modalInstance) {
				this.modalInstance.dismiss();
			}
			//pour eviter que le composant entete ouvre le modal alert message
			this.$state.go(this.getUrlEdit(), { id: id, genre: this.genreSite, fromSave: isFromSave });
		}
	}

	async confirmer() {
		const success = await this.sauvegarder();
		if (success) {
			this.annuler(success);
		}
	}

	annuler(success) {
		console.log('BACK FROM DAP', this.fromDap);
		console.log('this.RouterHistoryService', this.RouterHistoryService);
		if (this.fromDap) {
			if (!success && this.site.id) {
				console.log('site id back', this.site.id);

				this.RouterHistoryService.back({ transporteurId: this.site.id, transporteurIndex: this.$stateParams.index });
			} else {
				console.log('success back', success);
				this.RouterHistoryService.back({ transporteurId: success, transporteurIndex: this.$stateParams.index });
			}

			return;
		}

		if (this.$stateParams.parentState == 'clients-divers.edit') {
			return this.$state.go('clients-divers.list');
		}

		// Differentes pages de retour possibles.
		// Si la creation du site est faite lors de la transformation en commande d'une proposition
		if (!this.RouterHistoryService.back()) {
			if (this.$stateParams.parentState == 'offres.commande') {
				this.$state.go('offres.commande', { id: this.$stateParams.propositionId, clientId: success });
			} else if (this.$stateParams.parentState == 'clients-divers.new') {
				this.$state.go('clients-divers.new');
			} else if (this.$stateParams.parentState == 'clients-divers.edit') {
				this.$state.go('clients-divers.edit', { id: 20 });
			} else {
				if (this.modalInstance) {
					this.modalInstance.dismiss();
				} else {
					this.$state.go(this.getUrlListe(), { genre: this.genreSite });
				}
			}
		}
	}

	getUrlListe() {
		switch (this.genreSite) {
			case 'commerciaux':
				return 'sites.list';
			case 'clients':
				return 'clients.list';
			case 'producteurs':
				return 'producteurs.list';
			case 'fournisseurs':
				return 'fournisseurs.list';
			case 'transporteurs':
				return 'transporteurs.list';
			default:
				return 'sites.list';
		}
	}

	getUrlEdit() {
		switch (this.genreSite) {
			case 'commerciaux':
				return 'sites.edit';
			case 'clients':
				return 'clients.edit';
			case 'producteurs':
				return 'producteurs.edit';
			case 'fournisseurs':
				return 'fournisseurs.edit';
			case 'transporteurs':
				return 'transporteurs.edit';
			default:
				return 'sites.edit';
		}
	}

	filtrer() {
		this.$state.go('donnee-filtrees.list', { id: this.site.id, type: 2 });
	}

	checkGeneriqueDisabled = () => {
		return new Promise((resolve) => {
			//Si non générique et que des clients divers sont associés ou sélectionnés
			if (!this.site.entete.isGenerique && this.site.entete.idClientsDivers && this.site.entete.idClientsDivers.length > 0) {
				const _this = this;
				const modalInstance = this.ModalService.confirm({
					modalTitle: this.$translate.instant('SITES.POPUP_WARNING_GENERIQUE_DISABLED_TITLE'),
					modalMsg: this.$translate.instant('SITES.POPUP_WARNING_GENERIQUE_DISABLED_MESSAGE'),
					headerClass: 'modal-info'
				});
				modalInstance.result
					.then(function () {
						//Clique sur OK : on supprime les clients divers
						_this.site.entete.idClientsDivers = null;
					})
					.catch(function () {
						//Clique sur NON : on fait rien
					})
					.finally(function () {
						//On est bon si on a plus de clients divers
						resolve(_this.site.entete.idClientsDivers == null);
					});
			} else resolve(true);
		});
	};

	checkValidity() {
		let validity = true;
		if (this.fromDap) {
			if (!this.site.entete.isValid()) {
				this.$scope.$broadcast('siteEnteteValidations');
				return false;
			}
		}

		let firstScroll = true;
		if (!this.site.entete.isValid()) {
			if (firstScroll) {
				this.scrollToOnglet('entete');
				firstScroll = false;
			}
			this.ongletOpen.isEnteteOpen = true;
			validity = false;
			this.$scope.$broadcast('siteEnteteValidations');
		}

		if (this.site.caracteristiquesUtilisateur && !this.site.caracteristiquesUtilisateur.isValid()) {
			if (firstScroll) {
				this.scrollToOnglet('caracteristiquesUtilisateur');
				firstScroll = false;
			}

			this.ongletOpen.isCaracteristiqueUtilisateurOpen = true;
			validity = false;
			this.$scope.$broadcast('siteCaracteristiquesCommercialValidations');
		}

		if (this.site.caracteristiquesClient && !this.site.caracteristiquesClient.isValid()) {
			if (firstScroll) {
				this.scrollToOnglet('caracteristiquesClient');
				firstScroll = false;
			}

			this.ongletOpen.isCaracteristiqueClientOpen = true;
			validity = false;
			this.$scope.$broadcast('siteCaracteristiquesClientValidations');
		}

		if (this.site.caracteristiquesProducteur && !this.site.caracteristiquesProducteur.isValid()) {
			if (firstScroll) {
				this.scrollToOnglet('caracteristiquesProducteur');
				firstScroll = false;
			}

			this.ongletOpen.isCaracteristiqueProducteurOpen = true;
			validity = false;
			this.$scope.$broadcast('siteCaracteristiquesProducteurValidations');
		}

		if (this.site.caracteristiquesFournisseur && !this.site.caracteristiquesFournisseur.isValid()) {
			if (firstScroll) {
				this.scrollToOnglet('caracteristiquesFournisseur');
				firstScroll = false;
			}

			this.ongletOpen.isCaracteristiqueFournisseurOpen = true;
			validity = false;
			this.$scope.$broadcast('siteCaracteristiquesFournisseurValidations');
		}

		if (this.site.caracteristiquesTransporteur && !this.site.caracteristiquesTransporteur.isValid()) {
			if (firstScroll) {
				this.scrollToOnglet('caracteristiquesTransporteur');
				firstScroll = false;
			}

			this.ongletOpen.isCaracteristiqueTransporteurOpen = true;
			validity = false;
			this.$scope.$broadcast('siteCaracteristiquesTransporteurValidations');
		}

		return validity;
	}

	scrollToOnglet(id) {
		this.$location.hash(id);
		this.$anchorScroll();
	}

	onUpdateEntete(entete) {
		this.site.entete = entete;
	}

	onUpdateCaracteristiquesUtilisateur(caracteristiquesUtilisateur) {
		this.site.caracteristiquesUtilisateur = caracteristiquesUtilisateur;
	}

	onUpdateCaracteristiquesProducteur(caracteristiquesProducteur) {
		this.site.caracteristiquesProducteur = caracteristiquesProducteur;
	}

	onUpdateCaracteristiquesClient(caracteristiquesClient) {
		this.site.caracteristiquesClient = caracteristiquesClient;
	}

	onUpdateCaracteristiquesFournisseur(caracteristiquesFournisseur) {
		this.site.caracteristiquesFournisseur = caracteristiquesFournisseur;
	}

	onUpdateCaracteristiquesTransporteur(caracteristiquesTransporteur) {
		this.site.caracteristiquesTransporteur = caracteristiquesTransporteur;
	}

	onUpdateNiveaux(niveaux) {
		this.site.niveaux = niveaux;
	}
	onUpdateEtatCompte(etatCompte) {
		this.site.etatCompte = etatCompte;
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	openTarifs() {
		const _this = this;
		_this.source = this.site;
		_this.domaine = 'siteCommercial';
		if (this.genreSite == 'clients') {
			_this.domaine = 'client';
		}
		this.$uibModal.open({
			template: '<tarifs source="$ctrl.source" domaine="$ctrl.domaine" modal-instance="$ctrl.uibModalInstance"></tarifs>',
			controller: [
				'$uibModalInstance',
				function ($uibModalInstance) {
					const $ctrl = this;
					$ctrl.source = _this.source;
					$ctrl.domaine = _this.domaine;
					$ctrl.uibModalInstance = $uibModalInstance;
				}
			],
			controllerAs: '$ctrl',
			size: 'xxl'
		}).result;
	}

	openGrilles() {
		const _this = this;
		_this.source = this.site;
		_this.domaine = 'siteCommercial';
		if (this.genreSite == 'clients') {
			_this.domaine = 'client';
		}
		if (this.genreSite == 'fournisseurs') {
			_this.domaine = 'fournisseur';
		}
		if (this.genreSite == 'transporteurs') {
			_this.domaine = 'transporteur';
		}
		this.$uibModal.open({
			template: '<grilles source="$ctrl.source" domaine="$ctrl.domaine" modal-instance="$ctrl.uibModalInstance"></grilles>',
			controller: [
				'$uibModalInstance',
				function ($uibModalInstance) {
					const $ctrl = this;
					$ctrl.source = _this.source;
					$ctrl.domaine = _this.domaine;
					$ctrl.uibModalInstance = $uibModalInstance;
				}
			],
			controllerAs: '$ctrl',
			size: 'xxl'
		}).result;
	}

	openImpressionPrix() {
		const _this = this;
		_this.source = this.site;
		const tarifType = {
			commerciaux: 1,
			clients: 3
		};

		const currentDomainData = {
			societeId: _this.site.entete.societeId === -1 ? null : _this.site.entete.societeId,
			siteId: _this.genreSite === 'commerciaux' ? _this.site.entete.id : null,
			tarifType: tarifType[_this.genreSite],
			genre: _this.genreSite,
			currentItemId: _this.site.entete.id
		};

		this.$uibModal.open({
			template:
				'<plan-impression-prix domaine="planimprprix" client-id="$ctrl.clientId" modal-instance="$ctrl.uibModalInstance" current-domain-data="$ctrl.currentDomainData"></plan-impression-prix>',
			controller: [
				'$uibModalInstance',
				function ($uibModalInstance) {
					const $ctrl = this;
					$ctrl.uibModalInstance = $uibModalInstance;
					$ctrl.clientId = _this.site.id;
					$ctrl.currentDomainData = currentDomainData;
				}
			],
			controllerAs: '$ctrl',
			size: 'xxl'
		}).result;
	}

	verifEtatCompte(genreLibelle) {
		if (genreLibelle == 'Commercial' || genreLibelle == 'Client') {
			return false;
		}
		return true;
	}

	verifAffichageEtatCompte() {
		if (this.site.genreLibelle == 'Commercial') {
			return false;
		}
		return true;
	}

	async setDefaultEtatCompte(id) {
		try {
			await this.SitesService.setDefaultEtatCompte(id, this.application);
		} catch (err) {
			this.notification.error('SITES.ETAT_COMPTE_AUTO_FAILED');
		}
	}

	formatDatesCertificat() {
		this.certificats.forEach((certificat) => {
			certificat.dateDebut = this.moment.utc(certificat.dateDebut, this.dateFormat);
			certificat.dateFin = this.moment.utc(certificat.dateFin, this.dateFormat);
		});
	}

	showMap() {
		const url = `https://www.openstreetmap.org/?mlat=${this.site.latitude}&mlon=${this.site.longitude}&zoom=14&layers=M`;
		window.open(url, 'carte');
	}

	onCaracteristiquesCount(count, type) {
		switch (type) {
			case 'Client':
				this.caracteristiquesClientCount = count;
				break;
			case 'Fournisseur':
				this.caracteristiquesFournisseurCount = count;
				break;
			case 'Producteur':
				this.caracteristiquesProducteurCount = count;
				break;
			case 'Transporteur':
				this.caracteristiquesTransporteurCount = count;
				break;
			case 'Utilisateur':
				this.caracteristiquesUtilisateurCount = count;
				break;
			default:
				console.warn('Unknown type:', type);
		}
	}
	getCaracteristiquesRenseigneesCount(type) {
		const key = `caracteristiques${type}`;
		if (this.site[key] && this.site[key].data) {
			return Object.values(this.site[key].data).filter((caract) => !isNaN(caract.id) && !(caract.value == null) && !(caract.value == ''))
				.length;
		}
		return 0;
	}
}
